module.exports = __webpack_public_path__ + "img/logo-full.47eb4ad3.svg";